/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.63   Rana simulation core release: 3.7.3   deployed on:  08:32AM (UTC) on September 25, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from "../runtime";
import type { FileReadOnly } from "./FileReadOnly";
import {
  FileReadOnlyFromJSON,
  FileReadOnlyFromJSONTyped,
  FileReadOnlyToJSON,
  FileReadOnlyToJSONTyped,
} from "./FileReadOnly";
import type { SavedStateTypeEnum } from "./SavedStateTypeEnum";
import {
  SavedStateTypeEnumFromJSON,
  SavedStateTypeEnumFromJSONTyped,
  SavedStateTypeEnumToJSON,
  SavedStateTypeEnumToJSONTyped,
} from "./SavedStateTypeEnum";
import type { Threshold } from "./Threshold";
import {
  ThresholdFromJSON,
  ThresholdFromJSONTyped,
  ThresholdToJSON,
  ThresholdToJSONTyped,
} from "./Threshold";

/**
 * Assumes simulation to be present on Serializer.
 *
 * Validates that the latest simulation status is either "created" or
 * "initialized".
 *
 * If the latest simulation status is "initialized" is also checks
 * if the simulation has been paused.
 *
 * Use this mixin to validate the creation or update of simulation event
 * resources like rain, wind etc
 * @export
 * @interface SavedStateOverview
 */
export interface SavedStateOverview {
  /**
   *
   */
  name?: string;
  /**
   *
   */
  type: SavedStateTypeEnum;
  /**
   *
   */
  created?: Date | null;
  /**
   * Time in simulation the savedstate has been created
   */
  createdTime?: number | null;
  /**
   * tags provided as a list of strings
   */
  tags?: Array<string>;
  /**
   *
   */
  expiry?: Date | null;
  /**
   * Time in simulation to create savedstate
   */
  time?: number | null;
  /**
   *
   */
  thresholds: Array<Threshold>;
  /**
   *
   */
  readonly file?: FileReadOnly;
  /**
   *
   */
  readonly id?: number;
  /**
   *
   */
  uuid?: string;
}

/**
 * Check if a given object implements the SavedStateOverview interface.
 */
export function instanceOfSavedStateOverview(value: object): value is SavedStateOverview {
  if (!("type" in value) || value["type"] === undefined) return false;
  if (!("thresholds" in value) || value["thresholds"] === undefined) return false;
  return true;
}

export function SavedStateOverviewFromJSON(json: any): SavedStateOverview {
  return SavedStateOverviewFromJSONTyped(json, false);
}

export function SavedStateOverviewFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): SavedStateOverview {
  if (json == null) {
    return json;
  }
  return {
    name: json["name"] == null ? undefined : json["name"],
    type: SavedStateTypeEnumFromJSON(json["type"]),
    created:
      json["created"] === undefined
        ? undefined
        : json["created"] === null
        ? null
        : parseDateTime(json["created"]),
    createdTime:
      json["created_time"] === undefined
        ? undefined
        : json["created_time"] === null
        ? null
        : json["created_time"],
    tags: json["tags"] == null ? undefined : json["tags"],
    expiry:
      json["expiry"] === undefined
        ? undefined
        : json["expiry"] === null
        ? null
        : parseDateTime(json["expiry"]),
    time: json["time"] === undefined ? undefined : json["time"] === null ? null : json["time"],
    thresholds: (json["thresholds"] as Array<any>).map(ThresholdFromJSON),
    file: json["file"] == null ? undefined : FileReadOnlyFromJSON(json["file"]),
    id: json["id"] == null ? undefined : json["id"],
    uuid: json["uuid"] == null ? undefined : json["uuid"],
  };
}

export function SavedStateOverviewToJSON(json: any): SavedStateOverview {
  return SavedStateOverviewToJSONTyped(json, false);
}

export function SavedStateOverviewToJSONTyped(
  value?: Omit<SavedStateOverview, "file" | "id"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    name: value["name"],
    type: SavedStateTypeEnumToJSON(value["type"]),
    created: value["created"] == null ? value["created"] : serializeDateTime(value["created"]),
    created_time: value["createdTime"],
    tags: value["tags"],
    expiry: value["expiry"] == null ? value["expiry"] : serializeDateTime(value["expiry"]),
    time: value["time"],
    thresholds: (value["thresholds"] as Array<any>).map(ThresholdToJSON),
    uuid: value["uuid"],
  };
}
